import { INIT_PAGINATION, LOAD_CONTENT, LOADING_START, LOADING_STOP, SHOW_PAGE } from '../constants/content'
import { showError } from './app'
import { __ } from '../services/translate'
import { logError } from '../utils/errors'
import { getQueryParam } from '../utils/url'
import config from '../config'

export const loadContent = () => async (dispatch, getState, api) => {
  dispatch({
    type: LOADING_START
  })
  try {
    const data = await api.loadContent()
    dispatch({
      type: LOAD_CONTENT,
      payload: data
    })
  } catch (e) {
    logError(e)
    dispatch(showError(__('Nastal problem při načitávaní dat')))
  } finally {
    dispatch({
      type: LOADING_STOP,
    })
  }
}

export const initPagination = (urlQueryString, total) => {
  let page = Number(getQueryParam(urlQueryString, config.pagination.key))
  if (!page || page < 1) {
    page = 1
  }
  return {
    type: INIT_PAGINATION,
    payload: {
      page,
      total,
    }
  }
}

export const showPage = (history, page) => {
  if (!page || page < 1) {
    page = 1
  }
  history.push(`?${config.pagination.key}=${page}`)
  return {
    type: SHOW_PAGE,
    payload: page
  }
}
